<app-internal-banner [message]="'This page is for crew only. Clients cannot view this page.'">
</app-internal-banner>

<!-- Text Wrapping Validation Errors Banner -->
<ng-container *ngIf="hasWrappingErrors && showErrors">
  <div class="row mb-2">
    <div class="col-12">
      <c11n-banner [size]="'small'" [variant]="'error'">
        <strong>Message text validation failed:</strong>
        <ul class="mb-0 mt-2">
          <li *ngFor="let error of textValidationErrors">{{ error }}</li>
        </ul>
      </c11n-banner>
    </div>
  </div>
</ng-container>

<!-- Warning Banner for Near Line Limit -->
<ng-container *ngIf="isNearLineLimit && !hasWrappingErrors">
  <div class="row mb-2">
    <div class="col-12">
      <c11n-banner [size]="'small'" [variant]="'warning'">
        <strong>Warning:</strong> You are near the maximum line limit. Only {{ maxLineCount - currentLineCount }} line(s) remaining.
      </c11n-banner>
    </div>
  </div>
</ng-container>

<form
  autocomplete="off"
  [formGroup]="formGroup"
  (ngSubmit)="submitForm($event)">

  <div class="row">
    <div class="col mb-3">
      <app-title [title]="'Add message'"></app-title>
    </div>
  </div>

  <!-- Message Number -->
  <div class="row">
    <div class="col-lg-3 col-md-4 col-sm-10 col-xs-12 c11n-space-stack-3x c11n-space--force">
      <label c11n-label for="message_number">Message number (required)</label>
      <c11n-input
        [hasError]="showErrors && formGroup.controls['message_number'].invalid"
      >
        <input
          c11nInput
          id="message_number"
          type="text"
          placeholder="Message number"
          [attr.readonly]="isWaiting ? true : null"
          formControlName="message_number"
        />
      </c11n-input>
      <c11n-hint-error
        *ngIf="showErrors && formGroup.controls['message_number'].invalid"
        errorText="Please enter a message number"
        hintErrorId="message-number-description"
        [hasError]="true"
      ></c11n-hint-error>
    </div>
  </div>

  <!-- Message Type -->
  <div class="row">
    <div class="col-lg-6 col-md-8 col-sm-10 col-xs-12 c11n-space-stack-3x c11n-space--force">
      <c11n-select
        labelText="Message type (required)"
        [hasCustomHintError]="true"
        [hasError]="showErrors && formGroup.controls['message_type'].invalid"
      >
        <select
          c11nSelectInput
          id="message_type"
          [attr.disabled]="isWaiting ? true : null"
          required
          formControlName="message_type"
        >
          <option value="" disabled selected>Select one</option>
          <option *ngFor="let type of messageTypes" [value]="type">{{ type }}</option>
        </select>
      </c11n-select>
      <c11n-hint-error
        *ngIf="showErrors && formGroup.controls['message_type'].invalid"
        errorText="Please select a message type"
        hintErrorId="message-type-description"
        [hasError]="true"
      ></c11n-hint-error>
    </div>
  </div>

  <ng-container *ngIf="showFundFields">
    <!-- Fund ID (Conditionally shown) -->
    <div class="row">
      <div class="col-lg-7 col-md-8 col-sm-10 col-xs-12 c11n-space-stack-3x c11n-space--force">
        <c11n-select
          labelText="Fund ID (required)"
          [hasError]="showErrors && formGroup.controls['fund_id'].invalid"
          [hasCustomHintError]="true"
          [hintText]="''"
        >
          <select
            c11nSelectInput
            id="fund_id"
            required
            [attr.disabled]="isWaiting ? true : null"
            formControlName="fund_id"
          >
            <option value="" disabled selected>Select one</option>
            <option *ngFor="let fundId of fundIds" [value]="fundId.fundPortId">{{ fundId | fundIdNameFormation }}</option>
          </select>
        </c11n-select>
        <c11n-hint-error
          *ngIf="showErrors && formGroup.controls['fund_id'].invalid"
          errorText="Please select a fund id"
          hintErrorId="fund-id-description"
          [hasError]="true"
        ></c11n-hint-error>
      </div>
    </div>

    <!-- Fund Code (Conditionally shown) -->
    <div class="row">
      <div class="col-lg-4 col-md-8 col-sm-10 col-xs-12 c11n-space-stack-3x c11n-space--force">
        <c11n-select
          labelText="Fund code (required)"
          [hasError]="showErrors && formGroup.controls['fund_code'].invalid"
          [hintText]="''"
          [hasCustomHintError]="true"
        >
          <select
            c11nSelectInput
            id="fund_code"
            required
            [attr.disabled]="isWaiting ? true : null"
            formControlName="fund_code"
          >
            <option value="" disabled selected>Select one</option>
            <option *ngFor="let fundCode of fundCodes" [value]="fundCode">{{ fundCode }}</option>
          </select>
        </c11n-select>
        <c11n-hint-error
          *ngIf="showErrors && formGroup.controls['fund_code'].invalid"
          errorText="Please select a fund code"
          hintErrorId="fund-code-description"
          [hasError]="true"
        ></c11n-hint-error>
      </div>
    </div>
  </ng-container>

  <!-- Permanent Message Checkbox -->
  <div class="row">
    <div class="col-lg-6 col-md-8 col-sm-10 col-xs-12 c11n-space-stack-3x c11n-space--force">
      <c11n-checkbox labelText="Permanent message">
        <input
          c11nCheckboxInput
          id="is-permanent"
          type="checkbox"
          formControlName="isPermanent"
          [attr.disabled]="isWaiting ? true : null"
        />
      </c11n-checkbox>
    </div>
  </div>

  <!-- Header -->
  <div class="row">
    <div class="col-lg-8 col-md-8 col-sm-10 col-xs-12 c11n-space-stack-3x c11n-space--force">
      <label c11n-label for="header">Header</label>
      <c11n-input>
        <input
          c11nInput
          id="header"
          placeholder="Header (optional)"
          [attr.readonly]="isWaiting ? true : null"
          formControlName="header"
        />
      </c11n-input>
    </div>
  </div>

  <!--Text Input with Live Validation & Stats -->
  <div class="row">
    <div class="col-lg-8 col-md-8 col-sm-10 col-xs-12 c11n-space-stack-3x c11n-space--force">
      <div class="d-flex justify-content-between align-items-center mb-1">
        <label c11n-label for="text">Text (required)</label>
      </div>

      <div *ngIf="messageLines.length === 0">
        <c11n-banner [size]="'small'" [variant]="'basic'" [hasCloseControl]="false">
          Please select a message type.
        </c11n-banner>
      </div>

      <!-- Multiple Input Boxes: One per message line -->
      <div *ngIf="messageLines.length > 0">
        <div *ngFor="let line of messageLines; let i = index" class="mb-3">

          <!-- Label for each line with character counter -->
          <div class="d-flex justify-content-between align-items-center mb-2">
          <label c11n-label [attr.for]=" 'line-' + i ">
            Line {{ i+1 }}
            <span *ngIf="i === 0" class="text-danger">*</span>
          </label>
          <small [ngClass]="getCharCountTextClass(i)">
            {{ getCharCountMessage(i)}}
          </small>
          </div>

          <!-- Input field -->
          <c11n-input [hasError]="showErrors && line.invalid">
            <input
              #messageLineInput
              c11nInput
              type="text"
              [id]=" 'line-' + i"
              [formControl]="line"
              [attr.readonly]="isWaiting ? true : null"
              [placeholder]=" 'Enter text for line ' + (i + 1) "
              (input)="onMessageLineInput(i, $event)"
              (keydown)="onMessageLineKeydown(i, $event)"
              (paste)="onMessageLinePaste(i, $event)"
            />
          </c11n-input>

           <!-- Warning: Character limit reached -->
            <div *ngIf="isLineLimitReached(i)" class="text-danger small mt-1">
              Character limit reached for this line
            </div>

          <!-- Error: Line 1 is required -->
          <c11n-hint-error 
            *ngIf="showErrors && line.invalid && line.hasError('required')"
            [errorText]=" 'Line ' + (i+1) + ' is required' "
            [hintErrorId]=" 'line-' + i + '-required-error' "
            [hasError]="true"
          ></c11n-hint-error>

          <!-- Error: Character Limit exceeded -->
          <c11n-hint-error
            *ngIf="showErrors && line.invalid && line.hasError('maxlength')"
            [errorText]="'Line ' + (i+1) + ' exceeds maximum character limit of ' + maxCharsPerLine"
            [hintErrorId]="'line-' + i + '-maxlength-error'"
            [hasError]="true"
          ></c11n-hint-error>

        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="messageLines.length > 0 && hasAnyLineContent()">
    <div class="col-lg-8 col-md-8 col-sm-10 col-xs-12 c11n-space-stack-3x c11n-space--force">
      <div class="wrapped-text-preview">
        <details open>
          <summary class="preview-header">
            <strong>
              <i class="bi bi-eye"></i> Live Preview (Wrapped Text)
            </strong>
          </summary>
          <div class="preview-content mt-2">
            <div class="wrapped-lines-container">
              <div *ngFor="let line of messageLines; let i = index">
                <ng-container *ngIf="line.value !== null && line.value !== undefined">
                  <span class="line-number">{{ i+1 }}.</span>
                  <span class="line-text" style="white-space: pre-wrap; word-break: break-word">{{line.value}}</span>
                  <span class="char-count" [class.text-danger]="getNormalizedLength(line.value) > maxCharsPerLine">
                    ({{ getNormalizedLength(line.value) }}/{{ maxCharsPerLine }})
                  </span>
                </ng-container>
              </div>
            </div>
          </div>
        </details>
      </div>
    </div>
  </div>

  <!-- Action Buttons -->
  <div class="row">
    <div class="col-lg-8 col-md-8 col-sm-10 col-xs-12 c11n-space-stack-3x c11n-space--force">
      <div class="d-flex flex-column flex-sm-row justify-content-between button_between_gap">

        <!-- Left side: Submit & Cancel buttons -->
        <div class="d-flex flex-column flex-sm-row gap-2 order-2 order-sm-1 button_between_gap">
          <c11n-button
            labelText="Submit"
            buttonType="submit"
            [isInvalid]="formGroup.invalid"
            [isWaiting]="isWaiting"
            [fullWidth]="(responsiveService.isMobile$ | async) ?? false"
            class="order-2 order-sm-1"
          ></c11n-button>

          <c11n-button
            labelText="Cancel"
            variant="secondary"
            [fullWidth]="(responsiveService.isMobile$ | async) ?? false"
            class="order-1 order-sm-2"
            (clickEvent)="cancelButtonHandler()"
          ></c11n-button>
        </div>

        <!-- Right side: Preview & Clear buttons -->
        <div *ngIf="hasFormData()"
             class="button_between_gap d-flex flex-column flex-sm-row gap-2 order-1 order-sm-2 align-items-md-center">
          <c11n-button
            labelText="Clear"
            variant="ghost"
            [fullWidth]="(responsiveService.isMobile$ | async) ?? false"
            size="small"
            (clickEvent)="resetForm()"
          ></c11n-button>

          <c11n-button
            labelText="Preview"
            variant="secondary"
            size="small"
            (clickEvent)="onPreviewViewMessage()"
            [fullWidth]="(responsiveService.isMobile$ | async) ?? false"
          ></c11n-button>
        </div>
      </div>
    </div>
  </div>

</form>

<!-- Modals -->
<app-confirm-submit
  #confirmationModal
  [headingText]="'Once you click Ok data will be lost.'"
  [variant]="'basic'"
  [confirmButtonText]="'Ok, go back'"
  [cancelButtonText]="'No, stay'"
  [confirmButtonVariant]="'primary'"
  (confirmEvent)="leavePage()"
  (cancelEvent)="stayOnPage()"
  (closeEvent)="stayOnPage()"
></app-confirm-submit>

<app-confirm-submit
  #submitConfirmationModal
  [variant]="'basic'"
  [headingText]="'Are you ready to add the message?'"
  [confirmButtonText]="'Yes, add message'"
  [cancelButtonText]="'No, go back'"
  [confirmButtonVariant]="'primary'"
  (confirmEvent)="confirmSubmit()"
  (cancelEvent)="cancelSubmit()"
  (closeEvent)="cancelSubmit()"
></app-confirm-submit>

<!--Preview Modal with Wrapped Lines -->
<app-preview-message
  #messagePreviewModal
  [header]="formGroup.get('header')?.value || ''"
  [messageTextLines]="getPreviewMessageLines()"
  [headingText]="'Preview message text'"
  (closeEvent)="onClosePreviewMessage()"
></app-preview-message>
